import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { Validators } from "@angular/forms";
import { QuestionBase } from "../../../shared/components/dynamic-form/question-base";
import { TextboxQuestion } from "../../../shared/components/dynamic-form/question-textbox";

@Injectable()
export class RegisterService {
  constructor() {}
  generateQuestions(options?: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: number;
  }): Observable<QuestionBase<string | boolean>[]> {
    const questions: QuestionBase<string | boolean>[] = [
      new TextboxQuestion({
        value: options?.firstName,
        key: "firstName",
        label: "First Name",
        required: true,
        order: 1,
        errors: [
          {
            key: "firstname",
            validator: Validators.pattern("^[a-zA-Z0-9]*$"),
            message: "Please enter a valid firstname",
          },
        ],
      }),
      new TextboxQuestion({
        value: options?.lastName,
        key: "lastName",
        label: "Last Name",
        required: true,
        order: 2,
        errors: [
          {
            key: "lastname",
            validator: Validators.pattern("^[a-zA-Z0-9]*$"),
            message: "Please enter a valid lastname",
          },
        ],
      }),
      new TextboxQuestion({
        value: options?.email,
        key: "email",
        label: "Email",
        required: true,
        order: 3,
        errors: [
          {
            key: "email",
            validator: Validators.email,
            message: "Please enter a valid email",
          },
        ],
      }),
      new TextboxQuestion({
        value: options?.phone.toString(),
        key: "phone",
        label: "Phone",
        required: false,
        order: 4,
        errors: [
          {
            key: "phone",
            validator: Validators.pattern(/^$|^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$/),
            message: "Please enter a valid phone",
          },
        ],
      }),
    ];

    return of(questions.filter((field) => field).sort((a, b) => a.order - b.order));
  }
}
